<template>
  <div class="login-page box-sizing w-full flex flex-wrap overflow-auto">
    <div class="login-left">
      <div class="brand flex items-center gap-8">
        <img src="../assets/logo.png" alt="" class="brand-logo">
        <div class="brand-title">金河生物数字化货运平台</div>
      </div>
      <div class="login-illustration-wrap flex items-center justify-center">
        <img src="../assets/login_01.png" alt="" class="login-illustration">
      </div>
    </div>
    <div class="login-right relative">
      <div class="absolute login-right-one">
        <img src="../assets/login_03.png" alt="" class="w-90 h-100">
      </div>
      <div class="absolute login-right-two">
        <img src="../assets/login_02.png" alt="" class="w-90 h-100">
      </div>

      <div class="login-card">
        <div class="card-title">
          <span class="text-333">欢迎登录！</span>
          <div class="w-48 h-6 bg-primary-bar"></div>
        </div>
        <el-form
        ref="loginForm"
        :model="loginForm"
        class="form"
        auto-complete="on"
        label-position="left"
        @keyup.enter.native="handleLogin"
      >
        <el-form-item label="手机号/用户名" prop="username" class="username-item">
          <el-input
            v-model="loginForm.username"
            placeholder="请输入手机号/用户名"
            name="username"
            clearable
            type="text"
            tabindex="1"
            auto-complete="on"
          />
        </el-form-item>
        <el-form-item label="登录密码" prop="password" class="username-item">
          <el-input
            v-model="loginForm.password"
            placeholder="请输入登录密码"
            name="password"
            type="password"
            clearable
            tabindex="2"
            auto-complete="on"
          />
        </el-form-item>
        <el-row :gutter="20">
          <el-col :span="16">
            <el-form-item label="验证码" prop="captcha" class="username-item">
              <el-input
                v-model="loginForm.captcha"
                placeholder="请输入验证码"
                class="captcha-input"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="8" >
            <img :src="captchaImg" class="w-100 h-44 cursor-pointer captcha-img" @click="fetchCaptcha" alt="captcha" />
          </el-col>
        </el-row>

        <el-checkbox v-model="loginForm.rememberMe" class="remember-checkbox">
          30 天内保持登录
        </el-checkbox>

        <el-button
          :loading="loading"
          type="primary"
          class="login-btn"
          @click.native.prevent="handleLogin"
        >
          立即登录
        </el-button>
      </el-form>
      </div>
    </div>
      <!-- <div class="copyright">版权所有© 金河生物 晋ICP备2023023524号-3</div> -->
  </div>
</template>

<script>
import loginApi from '@/api/login'
import { sk } from '@/config'
import { persistAuthentication } from '@/utils/request'
export default {
  name: 'Login',
  data() {
    return {
      loginForm: {
        username: '',
        password: '',
        captcha: '',
        rememberMe: false
      },
      loading: false,
      passwordType: 'password',
      redirect: undefined,
      captchaText: '',
      captchaKey: '',
      captchaImg: ''
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  mounted() {
    this.fetchCaptcha()
  },
  methods: {
    async fetchCaptcha() {
      try {
        const res = await loginApi.getCaptcha()
        if (res.code === 200) {
          this.captchaKey = res.data.captchaKey
          this.captchaImg = `data:image/jpeg;base64,${res.data.captcha}`
        }
      } catch (e) {
      }
    },
    async handleLogin() {
      if (!this.loginForm.username) {
        this.$message.error('请输入手机号/用户名')
        return
      }
      if (!this.loginForm.password) {
        this.$message.error('请输入登录密码')
        return
      }
      if (!this.loginForm.captcha) {
        this.$message.error('请输入验证码')
        return
      }
      this.loading = true
      const payload = {
        account: this.loginForm.username,
        pwd: this.loginForm.password,
        code: this.loginForm.captcha,
        key: this.captchaKey,
        rememberMe: this.loginForm.rememberMe
      }
      loginApi.login(payload).then(res => {
        if (res.code === 200) {
          const data = res.data || {}
          
          // 确保token存在且有效
          if (!data.token) {
            this.$message.error('登录失败，未获取到有效token')
            return
          }
          
          // 访问令牌仅保存在当前标签页的 sessionStorage，刷新 Cookie 由浏览器 HttpOnly 管理。
          if (!persistAuthentication(data)) {
            this.$message.error('登录状态保存失败，请重试')
            return
          }
          this.loginForm.password = ''
          
          localStorage.removeItem(sk('menus'))
          
          this.$message.success('登录成功')
          
          // 使用 setTimeout 避免重定向循环，确保token已保存
          setTimeout(() => {
            const targetPath = this.redirect || '/'
            
            // 直接跳转，不使用 catch 避免触发额外的API调用
            this.$router.replace(targetPath).then(() => {
              // 路由跳转成功
            }).catch((error) => {
              // 如果跳转失败，尝试跳转到默认页面
              this.$router.replace('/').then(() => {
                // 跳转到根路径成功
              }).catch(() => {
                // 最后尝试刷新页面
                window.location.href = '/'
              })
            })
          }, 500)
        } else {
          this.fetchCaptcha()
        }
      }).catch(() => {
        // 登录失败刷新验证码
        this.fetchCaptcha()
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
<style scoped>
.login-page {
  background: rgba(237, 242, 250, 1);
  padding: 24px;
  align-items: stretch;
  height: 100vh;
}
.login-left {
  flex: 1;
  min-width: 320px;
  max-width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.brand-logo {
  width: 40px;
  height: 44px;
  flex-shrink: 0;
}
.brand-title {
  font-size: 28px;
  font-weight: bold;
  color: rgba(48, 49, 51, 1);
  line-height: 1.3;
}
.login-illustration-wrap {
  flex: 1;
  min-height: 200px;
}
.login-illustration {
  max-width: 100%;
  width: 100%;
  height: auto;
  max-height: 68vh;
  object-fit: contain;
}
.login-right {
  flex: 1;
  min-width: 320px;
  max-width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
}
.login-right-one {
  top: 5%;
  right: 18%;
  z-index: 99999;
}
.login-right-two {
  bottom: 3%;
  right: 8%;
}
.login-card {
  width: 100%;
  max-width: 480px;
  min-height: 480px;
  padding: 40px 40px 56px;
  box-sizing: border-box;
  opacity: 1;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.3);
  box-shadow: 0px 19px 39px rgba(22, 101, 250, 0.16);
  backdrop-filter: blur(20px);
}
.card-title {
  padding-bottom: 44px;
  padding-top: 24px;
}
.card-title span{
  display: inline-block;
  color: rgba(27, 52, 64, 1);
  font-size: 28px;
  font-weight: bold;
  line-height: 28px;
}
.card-title .bg-primary-bar{
  margin-top: 12px;
  background: rgba(22, 101, 250, 1);
}
.username-item {
    border: none !important;
    border-radius: 8px;
    box-sizing: border-box;
  }
  .form .el-form-item { margin-bottom: 24px; }
  .form >>> .el-input { width: 100%; max-width: 400px; }
  .form >>> .el-input__inner {
    height: 52px !important;
    line-height: 52px;
    opacity: 1;
    border-radius: 8px;
    border: none !important;
    background: #fff !important;
    padding-left: 12px;
  }
  /* 有值、聚焦、hover 时保持白底 */
  .form >>> .el-input .el-input__inner,
  .form >>> .el-input__inner:focus,
  .form >>> .el-input__inner:hover,
  .form >>> .el-input__inner:active {
    border: none !important;
    background: #fff !important;
  }
  /* 浏览器自动填充时也保持白底 */
  .form >>> .el-input__inner:-webkit-autofill,
  .form >>> .el-input__inner:-webkit-autofill:hover,
  .form >>> .el-input__inner:-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0 1000px #fff inset !important;
    box-shadow: 0 0 0 1000px #fff inset !important;
  }
  .form >>> .el-form-item__label {
    line-height: 30px;
    color: rgba(51, 51, 51, 1);
  }
  .captcha-row {
    position: relative;
  }
  .captcha-img {
    width: 100%;
    height: 52px;
    border-radius: 8px;
    cursor: pointer;
    margin-top: 30px;
    border: 1px solid rgba(220, 223, 230, 1);
  }

  .login-btn {
    width: 100%;
    height: 52px;
    background: rgba(22, 101, 250, 1) !important;
    border-radius: 4px;
    border: none;
    margin: 30px auto 56px;
  }

  .remember-checkbox {
    display: block;
    margin-top: 4px;
    color: rgba(51, 51, 51, 1);
  }

@media screen and (max-width: 1200px) {
  .login-page { padding: 20px; }
  .login-card {
    padding: 32px 28px 48px;
    min-height: 440px;
  }
  .card-title {
    font-size: 24px;
    padding-bottom: 48px;
  }
}
@media screen and (max-width: 992px) {
  .login-left,
  .login-right {
    max-width: 100%;
    min-width: 100%;
  }
  .login-left { padding: 16px 12px; }
  .brand-title { font-size: 22px; }
  .login-illustration { max-height: 40vh; }
  .login-right { padding: 16px 12px; }
  .login-card {
    margin: 0;
    max-width: 100%;
    min-height: 420px;
    padding: 32px 24px 40px;
  }
}
@media screen and (max-width: 576px) {
  .login-page { padding: 12px; }
  .login-left { padding: 12px 8px; }
  .brand { margin-bottom: 16px; }
  .brand-title { font-size: 18px; }
  .login-illustration-wrap { min-height: 160px; }
  .login-illustration { max-height: 28vh; }
  .login-right { padding: 12px 8px; }
  .login-card {
    min-height: 360px;
    padding: 24px 20px 32px;
  }
  .card-title {
    font-size: 22px;
    padding-bottom: 32px;
  }
  .username-item {
    height: 48px;
    line-height: 48px;
    padding: 10px 14px;
  }
  .form >>> .el-input__inner {
    height: 26px !important;
    line-height: 26px;
  }
  .captcha-img {
    right: -8px;
    width: 90px;
    height: 40px;
  }
  .captcha-row >>> .el-input__inner {
    padding-right: 98px !important;
  }
  .login-btn {
    height: 48px;
    margin: 48px auto 40px;
  }
}

  .copyright {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    color: rgba(144, 147, 153, 1);
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
  }
</style>
